import { PROFILE, CHANGE_PASSWORD, GET_BIDDING_AUCTION } from "../constant/index";

const INITIAL_STATE = {
  data: {},
  auction: {},
  loading: true,
  passwordLoading: false,
  passwordSuccess: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${PROFILE}_REQUEST`:
      return {
        ...state,
        loading: true,
      };
    case `${PROFILE}_SUCCESS`: {
      // GET returns { user, county[], country[] }.
      // PUT returns a flat user object (country/county as ids), which must not
      // replace the option lists or the page crashes on .map.
      const payload = action.payload || {};
      const isFullProfile =
        payload.user != null ||
        Array.isArray(payload.county) ||
        Array.isArray(payload.country);

      if (isFullProfile) {
        return {
          ...state,
          data: payload,
          loading: false,
        };
      }

      const prevUser = state.data?.user || {};
      const nextUser = {
        ...prevUser,
        ...payload,
      };
      // PUT often returns image: null even after upload — keep the prior avatar.
      if (!payload.image && prevUser.image) {
        nextUser.image = prevUser.image;
      }

      return {
        ...state,
        data: {
          ...state.data,
          user: nextUser,
        },
        loading: false,
      };
    }

    case `${PROFILE}_FAIL`:
    case `${PROFILE}_ERROR`:
      return {
        ...state,
        loading: false,
      };

    case `${CHANGE_PASSWORD}_REQUEST`:
      return {
        ...state,
        passwordLoading: true,
        passwordSuccess: false,
      };
    case `${CHANGE_PASSWORD}_SUCCESS`:
      return {
        ...state,
        passwordLoading: false,
        passwordSuccess: true,
      };

    case `${CHANGE_PASSWORD}_FAIL`:
    case `${CHANGE_PASSWORD}_ERROR`:
      return {
        ...state,
        passwordLoading: false,
        passwordSuccess: false,
      };

    case `${GET_BIDDING_AUCTION}_REQUEST`:
      return {
        ...state,
        auctionLoading: true,
      };
    case `${GET_BIDDING_AUCTION}_SUCCESS`:
      return {
        ...state,
        auction: action.payload,
        auctionLoading: false,
      };

    case `${GET_BIDDING_AUCTION}_FAIL`:
    case `${GET_BIDDING_AUCTION}_ERROR`:
      return {
        ...state,
        auctionLoading: false,
      };
  }
  return state;
};
